import { type FC } from 'react'
import { usePreciseFPContactSync } from '../IntegrationSpecificSettings/PreciseFP/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const PreciseFPCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = usePreciseFPContactSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync,
    calendarSync: false,
    isSyncDisabled: false,
    isFetching: contact.isFetching,
    isSaving: contact.isSaving,
    save: async (patch) => {
      if (patch.contactSync !== undefined) {
        await contact.saveAutoSync(patch.contactSync)
      }
    },
  }

  return <>{children(settings)}</>
}
